import * as ko from "knockout";
import { CustomObservables } from "CustomObservables";
import entityBase from "entityBase";
import { address } from "entitiesE";
import { request_contact } from "entitiesE";
import { request_text } from "entitiesE";
import { request_unit } from "entitiesE";
import { place, attachment_wrapper } from "organized";

export class request_dto extends entityBase {
  action_already_taken: KnockoutObservable<string>;
  actual_result: KnockoutObservable<string>;
  attached_product: KnockoutObservable<string>;
  created_by: KnockoutObservable<string>;
  created_dttm: KnockoutObservable<Date>;
  formattedcreated_dttm: any;
  cross_reference: KnockoutObservable<string>;
  cust_prob_descr: KnockoutObservable<string>;
  place_id: KnockoutObservable<string>;
  request_id: KnockoutObservable<string>;
  req_category: KnockoutObservable<string>;
  req_class: KnockoutObservable<string>;
  req_group: KnockoutObservable<string>;
  req_status: KnockoutObservable<string>;
  req_type: KnockoutObservable<string>;
  status: KnockoutObservable<string>;
  toner_color_c: KnockoutObservable<string>;
  toner_color_k: KnockoutObservable<string>;
  toner_color_m: KnockoutObservable<string>;
  toner_color_y: KnockoutObservable<string>;
  toner_waste: KnockoutObservable<string>;
  user_def1: KnockoutObservable<string>;
  user_def2: KnockoutObservable<string>;
  user_def3: KnockoutObservable<string>;
  user_def4: KnockoutObservable<string>;
  user_def6: KnockoutObservable<string>;
  user_def8: KnockoutObservable<string>;
  user_def9: KnockoutObservable<string>;
  user_def11: KnockoutObservable<string>;
  user_def13: KnockoutObservable<string>;
  user_def14: KnockoutObservable<string>;
  user_def16: KnockoutObservable<string>;
  user_def17: KnockoutObservable<string>;
  user_def10: KnockoutObservable<string>;
  user_def21: KnockoutObservable<string>;
  user_def23: KnockoutObservable<string>;
  user_def_dttm1: KnockoutObservable<Date>;
  formatteduser_def_dttm1: any;
  user_def_dttm2: KnockoutObservable<Date>;
  formatteduser_def_dttm2: any;
  user_def_num1: KnockoutObservable<number>;
  user_def_num2: KnockoutObservable<number>;
  place: KnockoutObservable<place>;
  address: KnockoutObservable<address>;
  request_attachment: KnockoutObservableArray<attachment_wrapper>;
  request_contact: KnockoutObservableArray<request_contact>;
  request_text: KnockoutObservableArray<request_text>;
  request_unit: KnockoutObservableArray<request_unit>;
  readonly: KnockoutObservable<boolean>;
  rejected: KnockoutObservable<boolean>;
  person_id_owner: KnockoutObservable<string>;
  constructor(item?: any) {
    super();
    this.action_already_taken = ko.observable(item?.action_already_taken);
    this.actual_result = ko.observable(item?.actual_result);
    this.attached_product = ko.observable(item?.attached_product);
    this.created_by = ko.observable(item?.created_by).extend({ maxLength: 32 });
    this.created_dttm = ko.observable(this.formatJSONDate(item?.created_dttm));
    this.formattedcreated_dttm = CustomObservables.formattedDateTimeObservable(this.created_dttm);
    this.cross_reference = ko.observable(item?.cross_reference).extend({ maxLength: 64 });
    this.cust_prob_descr = ko.observable(item?.cust_prob_descr ?? "");
    this.place_id = ko.observable(item?.place_id).extend({ maxLength: 32 });
    this.request_id = ko.observable(item?.request_id).extend({ maxLength: 20 });
    this.req_category = ko.observable(item?.req_category).extend({ maxLength: 128 });
    this.req_class = ko.observable(item?.req_class).extend({ maxLength: 50 });
    this.req_group = ko.observable(item?.req_group).extend({ maxLength: 128 });
    this.req_status = ko
      .observable(
        item?.c_wty_claim_header_status_customer_view
          ? item?.c_wty_claim_header_status_customer_view?.wty_claim_status
          : item?.req_status
      )
      .extend({ maxLength: 50 });
    this.req_type = ko.observable(item?.req_type).extend({ maxLength: 50 });
    this.status = ko.observable(item?.status).extend({ maxLength: 128 });
    this.toner_color_c = ko.observable(item?.toner_color_c).extend({ maxLength: 5 });
    this.toner_color_k = ko.observable(item?.toner_color_k).extend({ maxLength: 5 });
    this.toner_color_m = ko.observable(item?.toner_color_m).extend({ maxLength: 5 });
    this.toner_color_y = ko.observable(item?.toner_color_y).extend({ maxLength: 5 });
    this.toner_waste = ko.observable(item?.toner_waste).extend({ maxLength: 5 });
    this.user_def11 = ko.observable(item?.user_def11).extend({ maxLength: 50 });
    this.user_def13 = ko.observable(item?.user_def13 ?? "");
    this.user_def14 = ko.observable(item?.user_def14 ?? "");
    this.user_def1 = ko.observable(item?.user_def1).extend({ maxLength: 128 });
    this.user_def2 = ko.observable(item?.user_def2).extend({ maxLength: 128 });
    this.user_def3 = ko.observable(item?.user_def3).extend({ maxLength: 128 });
    this.user_def4 = ko.observable(item?.user_def4).extend({ maxLength: 50 });
    this.user_def6 = ko.observable(item?.user_def6).extend({ maxLength: 50 });
    this.user_def8 = ko.observable(item?.user_def8).extend({ maxLength: 50 });
    this.user_def9 = ko.observable(item?.user_def9);
    this.user_def10 = ko
      .observable(
        item?.c_wty_claim_header_status_customer_view
          ? item?.c_wty_claim_header_status_customer_view?.wty_claim_status
          : undefined
      )
      .extend({ maxLength: 50 });
    this.user_def21 = ko.observable(item?.user_def21);
    this.user_def23 = ko.observable(item?.user_def23);
    this.user_def16 = ko.observable(item?.user_def16);
    this.user_def17 = ko.observable(item?.user_def17);
    this.user_def_dttm1 = ko.observable(this.formatJSONDate(item?.user_def_dttm1));
    this.formatteduser_def_dttm1 = CustomObservables.formattedDateObservable(this.user_def_dttm1);
    this.user_def_dttm2 = ko.observable(this.formatJSONDate(item?.user_def_dttm2));
    this.formatteduser_def_dttm2 = CustomObservables.formattedDateObservable(this.user_def_dttm2);
    this.user_def_num1 = ko.observable(item?.user_def_num1);
    this.user_def_num2 = ko.observable(item?.user_def_num2);
    this.place = ko.observable();
    this.address = ko.observable();
    this.request_attachment = ko.observableArray();
    this.request_contact = ko.observableArray();
    this.request_text = ko.observableArray();
    this.request_unit = ko.observableArray();
    this.person_id_owner = ko.observable(item?.person_id_owner).extend({ maxLength: 32 });
    if (item?.place) {
      this.place(new place(item.place));
    }
    if (item?.address) {
      this.address(new address(item.address));
    }
    if (item?.request_attachment) {
      this.request_attachment = <KnockoutObservableArray<attachment_wrapper>>(
        this.loadRelation(item, attachment_wrapper, "request_attachment", "array")
      );
    }
    if (item?.request_contact) {
      this.request_contact = <KnockoutObservableArray<request_contact>>(
        this.loadRelation(item, request_contact, "request_contact", "array")
      );
    }
    if (item?.request_text) {
      this.request_text = <KnockoutObservableArray<request_text>>(
        this.loadRelation(item, request_text, "request_text", "array")
      );
    }
    if (item?.request_unit) {
      this.request_unit = <KnockoutObservableArray<request_unit>>(
        this.loadRelation(item, request_unit, "request_unit", "array")
      );
    } else if (item?.model_id) {
      this.request_unit([new request_unit({ model_id: item.model_id })]);
    }
    this.readonly = ko.observable(this.user_def10() === "SUBMITTED");
    this.rejected = ko.observable(this.user_def10() === "REJECTED_FI");
  }
}
